import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 5B692392-DA8F-40F2-948F-D81832ABA465
 * name cellphone-information
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-information.svg
 * tags
 * - Cellphone / Phone 
 */
export const CellphoneInformationIcon = createSvgIcon(<><path d="M13 7H11V9H13V7M13 11H11V17H13V11M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1M17 19H7V5H17V19Z" /></>, 'CellphoneInformationIcon');
export default CellphoneInformationIcon